import { isEmpty } from "lodash";

export const getSendRequestParams = ({
  auth,
  inFix = "",
  method= "read"
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/${inFix}.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];

  return {
    apiUrl,
    requestParams
  };
}

export const getCleanUpdatePayload = ({
  ports
}) => {

  if(isEmpty(ports)) return {}

  const waitingEditPorts = ports
  .filter(port => port.isWaitingEdit)
  .map(port => {
    const { isWaitingEdit, ...restPortProps } = port;
    return restPortProps;
  });

  const macAddress = ports.find(port => port.macAddress)?.macAddress ?? "";

  const cleanPayload = [{
    "deviceId": macAddress,
    "wired.port": waitingEditPorts
  }]

  return cleanPayload;
}